import React, { useState, useCallback } from 'react'
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import useStyles from './style';


const SupplementalCommentsViewer = (props) => {
    const {
        blockState,
        sideBar,
        supplementalCommentsInfo,
        isGlobalDownloadEnable,
        isGobalDownloadEnable,
        onGlobalDownload,
        globalDownloadTitle,
    } = props;
    const { chartData } = props.data;
    const classes = useStyles();
    const supplementalComments = Array.isArray(blockState?.supplementalInformationComments)
        ? blockState.supplementalInformationComments
        : [];

    const info = supplementalCommentsInfo || {};
    const hasCommentRows = supplementalComments.length > 0;
    const downloadNotDisabledByConfig =
        info.isGlobalDownloadEnable !== false &&
        info.isGobalDownloadEnable !== false &&
        isGlobalDownloadEnable !== false &&
        isGobalDownloadEnable !== false;
    const globalDownloadOn =
        hasCommentRows &&
        downloadNotDisabledByConfig &&
        (typeof onGlobalDownload === 'function' || onGlobalDownload == null);
    const downloadTooltipTitle =
        globalDownloadTitle ||
        info.globalDownloadTitle ||
        info.downloadTitle ||
        'Download';

    const handleGlobalDownloadCommentsExcel = useCallback(() => {
        const rows = Array.isArray(blockState?.supplementalInformationComments)
            ? blockState.supplementalInformationComments
            : [];
        if (rows.length === 0) {
            toast.info('No comments to download.');
            return;
        }
        const i = supplementalCommentsInfo || {};
        const authorLabel = i.downloadAuthorLabel || 'Author';
        const dateLabel = i.downloadDateLabel || 'Date';
        const commentLabel = i.downloadCommentLabel || 'Comment';
        const headerRow = [authorLabel, dateLabel, commentLabel];
        const dataRows = rows.map((c) => [
            c?.by != null ? String(c.by) : '',
            c?.date != null ? String(c.date) : '',
            c?.comment != null ? String(c.comment) : '',
        ]);
        const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'Comments');
        const rawTitle = i.title || 'supplemental_comments';
        const safeName = String(rawTitle).replace(/[^\w\-]+/g, '_').slice(0, 80) || 'supplemental_comments';
        XLSX.writeFile(wb, `${safeName}.xlsx`);
    }, [blockState, supplementalCommentsInfo]);

    const handleDownloadClick = () => {
        if (typeof onGlobalDownload === 'function') {
            onGlobalDownload();
            return;
        }
        handleGlobalDownloadCommentsExcel();
    };
    const [newComment, setNewComment] = useState('');
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInMinutes = Math.floor((now - date) / (1000 * 60));

        if (diffInMinutes < 1) return 'Just now';
        if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hours ago`;

        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} days ago`;
    };

    const handleAddComment = () => {
        if (newComment.trim()) {
            const newCommentObj = {
                comment: newComment.trim(),
                date: new Date().toISOString(),
                by: props.members?.name || supplementalCommentsInfo?.unknownUser
            };

            const updatedComments = [...supplementalComments, newCommentObj];
            const updatedBlockState = {
                ...blockState,
                supplementalInformationComments: updatedComments
            };

            const payloadClone = JSON.parse(JSON.stringify(updatedBlockState));
            props.removeIdFields(payloadClone);

            const formData = {
                appId: props.appId,
                dataModelId: chartData?.selectedDataModel,
                dataUniqueId: props.data.chartUniqueId + '_updateobligation',
                opportunityId: props.match.params.id,
                payload: payloadClone,
            };
            props.updateOpportunity(formData);
            setNewComment('');
        }
    };

    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <React.Fragment>
            <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'start', boxSizing: 'border-box' }}>
                <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                        <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                        </div>
                        <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#424242', fontStyle: 'normal', lineHeight: '24px' }}>{supplementalCommentsInfo?.title}</Typography>
                    </div>
                    {globalDownloadOn ? (
                        <Tooltip title={downloadTooltipTitle}>
                            <IconButton
                                size="small"
                                aria-label={downloadTooltipTitle}
                                onClick={handleDownloadClick}
                                style={{ marginLeft: 4, padding: 4 }}
                            >
                                <img
                                    src="/media/createStepper/downloadIconNew.svg"
                                    alt=""
                                    style={{ width: 18, height: 18, display: 'block' }}
                                />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </div>
            </div>
            <div className={classes.supplementalWrap}>
                {supplementalComments.length === 0 ? (
                    <div className={classes.emptySupplemental}>
                        {supplementalCommentsInfo?.noSupplementalInfo}
                    </div>
                ) : (
                    <div className={classes.commentsScrollArea}>
                        {supplementalComments.map((comment, index) => (
                            <div key={index} className={classes.commentCard}>
                                <div className={classes.commentHeaderRow}>
                                    <Avatar className={classes.commentAvatar}>
                                        {getInitials(comment.by)}
                                    </Avatar>
                                    <div className={classes.commentMeta}>
                                        <Typography className={classes.commentAuthor}>
                                            {comment.by}
                                        </Typography>
                                        <Typography className={classes.commentDate}>
                                            {formatDate(comment.date)}
                                        </Typography>
                                    </div>
                                </div>
                                <div className={classes.commentBodyRow}>
                                    <div className={classes.commentBodySpacer} />
                                    <Typography className={classes.commentText}>
                                        {comment.comment}
                                    </Typography>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {
                    blockState?.['status'] !== 'Rejected' && blockState?.['status'] !== 'Completed' && (
                        <div className={classes.addCommentRow}>
                            <Avatar className={classes.commentAvatar}>
                                {getInitials(props.members?.name)}
                            </Avatar>

                            <div className={classes.addCommentBox}>
                                <textarea
                                    className={classes.addCommentTextarea}
                                    placeholder={supplementalCommentsInfo?.addSupplementalPlaceholder}
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}

                                />
                                <Button
                                    variant="contained"
                                    onClick={handleAddComment}
                                    disabled={!newComment.trim()}
                                    className={`${classes.addCommentButton} ${newComment.trim() ? classes.addCommentButtonActive : classes.addCommentButtonDisabled}`}
                                >
                                    {supplementalCommentsInfo?.addSupplementalInfo}
                                </Button>
                            </div>
                        </div>
                    )
                }

            </div>
        </React.Fragment>
    )
}

export default SupplementalCommentsViewer